utils = {
  
  
    getCookie: function (cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
        }
        return "";
    },
  
    getQueryStringParameter: function(variable) {
        let query = window.location.search.substring(1);
        let vars = query.split('&');
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split('=');
            if (pair[0] === variable) {
                return pair[1];
            }
        }

        return false;
    },

    updateQueryStringParameter: function(key, value, uri) {
        let re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
        let separator = uri.indexOf('?') !== -1 ? '&' : '?';
        if (uri.match(re)) {
            return uri.replace(re, '$1' + key + '=' + value + '$2');
        } else {
            return uri + separator + key + '=' + value;
        }
    },

    removeQueryStringParameter: function(key, uri) {
        var rtn = uri.split('?')[0],
            param,
            params_arr = [],
            queryString = uri.indexOf('?') !== -1 ? uri.split('?')[1] : '';

        if (queryString !== '') {
            params_arr = queryString.split('&');
            for (var i = params_arr.length - 1; i >= 0; i -= 1) {
                param = params_arr[i].split('=')[0];
                if (param === key) {
                    params_arr.splice(i, 1);
                }
            }
            rtn = rtn + '?' + params_arr.join('&');
        }

        return rtn;
    },
  
  	setInfiniteScroll: function(callback, toBottom) {     
      	toBottom = toBottom || 500;
      
        document.addEventListener('scroll', function() {
           if ($(window).scrollTop() >= $(document).height() - $(window).height() - toBottom) {
             
              callback();
           }
        });
    },
  
  	debounce: function(func, wait, immediate) {
      var timeout;
      return function() {
          var context = this, args = arguments;
          var later = function() {
              timeout = null;
              if (!immediate) func.apply(context, args);
          };
          var callNow = immediate && !timeout;
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
          if (callNow) func.apply(context, args);
      };
  	},
  
  	getTemplate: function(tmplName) {
  		let $tmplEl = $('script#' + tmplName);
      
        if ($tmplEl.length > 1) {
            throw 'many templates with name ' + tmplName;
        } else if ($tmplEl.length == 0) {
            throw 'not found templates with name ' + tmplName;
        } else {
            return this.templater($tmplEl.html());
        }
    },
  
    templater: function(text) {
      	var templaterConfig = templaterConfig = {
            evaluate: /{!([\s\S]+?)!}/g,
    		interpolate: /{!=([\s\S]+?)!}/g,
          	escape:  /{!-([\s\S]+?)!}/g
        };
      
        var escaper = /\\|'|\r|\n|\u2028|\u2029/g;
        var escapeChar = function(match) {
          var escapes = {
            "'": "'",
            '\\': '\\',
            '\r': 'r',
            '\n': 'n',
            '\u2028': 'u2028',
            '\u2029': 'u2029'
          };

          return '\\' + escapes[match];
        };
        var matcher = RegExp(
          [templaterConfig.interpolate.source, templaterConfig.evaluate.source].join('|') + '|$',
          'g'
        );
        var index = 0;
        var source = "__p+='";
        text.replace(matcher, function(match, interpolate, evaluate, offset) {
          source += text.slice(index, offset).replace(escaper, escapeChar);
          index = offset + match.length;

          if (interpolate) {
            source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
          } else if (evaluate) {
            source += "';\n" + evaluate + "\n__p+='";
          }

          return match;
        });
        source += "';\n";
        source = 'with(obj||{}){\n' + source + '}\n';
        source =
          "var __t,__p='',__j=Array.prototype.join," +
          "print=function(){__p+=__j.call(arguments,'');};\n" +
          source +
          'return __p;\n';

        try {
          var render = new Function('obj', source);
        } catch (e) {
          e.source = source;
          throw e;
        }

        var template = function(data) {
          return render.call(this, data);
        };

        template.source = 'function(obj){\n' + source + '}';

        return template;
      },
};